module.exports = __webpack_public_path__ + "static/img/clothing_01.2198df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_01.png
// module id = 8UeT
// module chunks = 0